// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1077":"80b1df27ab8a50ca","32875":"64e3848fb0b89c18","72366":"39d0992f0bf6ebe2"}[chunkId] + ".css";
};